// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"83":"df4923ea","94":"2d3bf65f","213":"a865e6d9","395":"72cbb987","411":"e17cf17d","471":"6bbb2d24","477":"ea2b315f"}[chunkId] + ".chunk.css";
};